import { useLayoutEffect, useRef } from 'react';

// Pannello aperto = una voce in più nella cronologia: il "indietro" del telefono
// (tasto o swipe iOS) chiude il pannello invece di uscire dai risultati.
// Pannelli uno sopra l'altro (annuncio → galleria): ognuno ha il suo livello
// e il "indietro" chiude solo quello in cima.
export function useBackToClose(open, onClose, enabled = true) {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  // Layout effect: la voce va creata ancora dentro il tocco, altrimenti
  // Safari e l'app Google la saltano tornando indietro.
  useLayoutEffect(() => {
    if (!open || !enabled) return undefined;
    const level = (window.history.state?.backLevel || 0) + 1;
    window.history.pushState({ ...(window.history.state || {}), backLevel: level }, '');
    let popped = false;
    const onPop = () => {
      if ((window.history.state?.backLevel || 0) >= level) return;
      popped = true;
      closeRef.current?.(false);
    };
    window.addEventListener('popstate', onPop);
    return () => {
      window.removeEventListener('popstate', onPop);
      // Chiuso con X/sfondo: togliamo la voce aggiunta. Se nel frattempo si è
      // navigato altrove (nuova voce senza il nostro livello) non tocchiamo nulla.
      if (!popped && window.history.state?.backLevel === level) window.history.back();
    };
  }, [open, enabled]);
}
